import { Component, computed, inject } from '@angular/core';
import { CardType } from '../../models/dzbank-configuration.model';
import { LandingpageConfigurationStateService } from 'app/shared/services/state/landingpage-configuration-state.service';

@Component({
  selector: 'ez-credit-card-image',
  imports: [],
  templateUrl: './credit-card-image.component.html',
  styleUrl: './credit-card-image.component.scss',
})
export class CreditCardImageComponent {
  private readonly landingpageConfigurationStateService = inject(LandingpageConfigurationStateService);
  readonly assetStackBucketUrl = this.landingpageConfigurationStateService.assetStackBucketUrl;
  readonly organisation = this.landingpageConfigurationStateService.organisation;
  readonly dzBankConfiguration = this.landingpageConfigurationStateService.cardInformation;
  readonly customLogos = computed(() => this.organisation()?.corporateDesign.logos.customLogos);

  readonly cardProductTexts = this.landingpageConfigurationStateService.cardProductTexts;
  readonly altText = computed(() => this.cardProductTexts()!.imageAlt);
  readonly imgSrc = computed(() => {
    const customLogos = this.customLogos();
    let relativePath: string;

    if (customLogos && customLogos['creditCard']) {
      relativePath = customLogos['creditCard'];
    } else {
      const imageFilenames = this.cardProductTexts()!.imageFilenames;
      if (this.dzBankConfiguration()!.cardType === CardType.VisaCard) {
        relativePath = 'public/' + imageFilenames[CardType.VisaCard];
      } else {
        relativePath = 'public/' + imageFilenames[CardType.MasterCard];
      }
    }

    return this.assetStackBucketUrl() + relativePath;
  });
}
